<template>
	<img v-bind="{src: _src, srcset: srcSet}"/>
</template>

<script>
export default {
	props: {
		src: {type: String, required: false},
		images: {type: Array, required: false},
		srcSet: {type: String, required: false},
		width: {required: false}, // ignore html attribute
		height: {required: false} // ignore html attribute
	},
	computed: {
		_src: (t) => t.images ? t.images.slice(-1)[0].path : t.src
	}
};
</script>
